import React from 'react'
const ColoredLine = ({ style }) => (
    <hr style={style} />
)
export default ColoredLine